<template>
  <div class="container" v-if="getAgencySettings">
    <div class="row">
      <div class="page-body">
        <div class="info-page-body support-page-body">
            <div class="support-title">
                <h1 class="page-title">{{ $t('getHelpWithYourFlightBooking') }}</h1>
                <router-link :to="{ name: 'SupportPage' }" class="btn-text">
                    <i class="fal fa-angle-left"></i>
                    {{ $t('backToSupportHome') }}
                </router-link>
            </div>

            <div class="content-panel tabs-title">
            <div class="panel-tabs">
                <ul>
                  <li v-for="(tab, index) in tabs" :key="index" :class="[{ active: currentTab === tab.ref }]">
                      <a @click="currentTab = tab.ref" :title="tab.name">{{ tab.name }}</a>
                  </li>
                </ul>
            </div>
            <div class="panel-body p-margin">
                <div class="support-tabgroup" v-if="currentTab === 'bookingLookup'">
                  <form @submit.prevent="lookupBooking('bookingLookupForm')" data-vv-scope="bookingLookupForm">
                      <div class="form-group">
                        <label for="fieldBookingReference">
                            {{ $t('bookingReference') }}: *
                            <i class="fal fa-info-circle" 
                                v-tooltip="$t('bookingReferenceParagraph')">
                            </i>
                        </label>
                        <input type="text" v-model="bookingLookup.orderReference" v-validate="'required'" id="fieldBookingReference" :name="$t('bookingReference')" />
                        <span v-if="showFieldErrors" class="invalid">{{ errors.first('bookingLookupForm.' + $t('bookingReference')) }}</span>
                      </div>

                      <div class="form-group">
                        <label for="fieldBookingEmailAddress">{{ $t('primaryEmailAddressUsedWhenBooking') }}: *</label>
                        <input type="email" v-model="bookingLookup.email" id="fieldBookingEmailAddress" v-validate="'required|email'" name="Email" />
                        <span v-if="showFieldErrors" class="invalid">{{ errors.first('bookingLookupForm.Email') }}</span>
                      </div>

                      <button type="submit" class="btn btn-lg btn-primary">{{ $t('viewMyBooking') }}</button>
                  </form>
                </div>

                <div class="support-tabgroup" v-if="currentTab === 'supportRequests'">
                
                  <form @submit.prevent="submitContactForm('supportRequestForm')" v-if="!formSubmitted && !formSubmitting" data-vv-scope="supportRequestForm">

                      <p>{{ $t('flightSupportFormParagraph') }}</p>
                      <p>{{ $t('forUrgentRequestsPleaseContactUsByPhone') }}: <strong>+1 (646) 558-7089 - ext 8</strong></p>

                      <p v-if="showFormError" class="invalid">{{ $t('formSubmissionFailure') }}</p>

                      <div class="form-group">
                        <label for="fieldName">{{ $t('name') }}: *</label>
                        <input type="text" v-model="contactEntry.name" v-validate="'required'" id="fieldName" :name="$t('name')" />
                        <span v-if="showFieldErrors" class="invalid">{{ errors.first('supportRequestForm' + $t('name')) }}</span>
                      </div>

                      <div class="form-group">
                        <label for="fieldEmailAddress">{{ $t('emailAddress') }}: *</label>
                        <input type="email" v-model="contactEntry.email" v-validate="'required|email'" id="fieldEmailAddress" :name="$t('emailAddress')" />
                        <span v-if="showFieldErrors" class="invalid">{{ errors.first('supportRequestForm.' + $t('emailAddress')) }}</span>
                      </div>

                      <div class="form-group">
                        <label for="fieldPhoneNumber">{{ $t('phoneNumber') }}:</label>
                        <input type="text" v-model="contactEntry.phone" id="fieldPhoneNumber" :name="$t('phoneNumber')" />
                      </div>

                      <div class="form-group">
                        <label for="fieldComments">{{ $t('pleaseOutlineYourSupportRequestInDetailBelow') }}: * 
                            <i class="fal fa-info-circle" v-tooltip="$t('supportCommentFieldParagraph')"></i>
                        </label>
                        <textarea v-model="contactEntry.comments" id="fieldComments" v-validate="'required'" :name="$t('comments')"></textarea>
                        <span v-if="showFieldErrors" class="invalid">{{ errors.first('supportRequestForm.' + $t('comments')) }}</span>
                      </div>

                      <button type="submit" class="btn btn-lg btn-primary">{{ $t('submit') }}</button>
                      
                  </form>
                  <div v-if="formSubmitting"><i class="fal fa-spin fa-spinner-third"></i></div>
                  <div v-if="formSubmitted" class="form-success">{{ $t('formSubmissionCompleted') }}</div>
                
                </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  name: 'FlightsSupport',
  data () {
    let self = this;
    return {
      title: 'Get Help With Your Flight Booking',
      showFormError: false,
      showFieldErrors: false,
      formSubmitting: false,
      formSubmitted: false,
      contactEntry: {
        name: '',
        email: '',
        phone: '',
        comments: ''
      },
      bookingLookup: {
        orderReference: '',
        email: ''
      },
      currentTab: 'bookingLookup',
      tabs: [ 
        {
          ref: 'bookingLookup',
          name: self.$t('viewUpdateMyBooking')
        },
        {
          ref: 'supportRequests',
          name: self.$t('emailAndPhoneSupport')
        }
      ]
    }
  },

  metaInfo() {
    let self = this;
    return {
      title: self.$t('customerSupport') + ' - ' + self.$t('getHelpWithYourFlightBooking')
    }
  },

  methods: {
    submitContactForm(scope) {
      let self = this;
      self.$validator.validateAll(scope).then((result) => {
        if (result) {
          self.formSubmitting = true;
          axios({
            method: "post",
            url: "/api/sendEmail",
            data: {
                to: 'customer.care@etgsupport.com',
                from: self.contactEntry.email,
                subject: 'Customer Support Request for ' + self.getAgencySettings.agencyName,
                text: 
                `
                Support Request Details:
                `
                + self.contactEntry.name + self.contactEntry.email + self.contactEntry.phone + self.contactEntry.comments,

                html: 
                `
                <h1 style="font-size: 24px; background-color: #f9f9f9; color: #41929C; padding: 20px;">New Support Request for ` + self.getAgencySettings.agencyName + `</h1>
                <p style="color: #000;">`
                + self.contactEntry.name +
                `<br />`
                + self.contactEntry.email +
                `<br />`
                + self.contactEntry.phone +
                `<br />`
                + self.contactEntry.comments +
                `</p>`
            }
          }).then(result2 => {
            if (result2)
            {
              self.formSubmitted = true;
              self.formSubmitting = false;
            }
            else {
              self.showFormError = true;
              self.formSubmitting = false;
            }
          })
        }
        if(!result) {
          self.showFieldErrors = true;
        }
      })
    },

    lookupBooking(scope) {
      let self = this;
      let orderReference = self.bookingLookup.orderReference;
      let email = self.bookingLookup.email;

      self.$validator.validateAll(scope).then((result) => {
        if (result) {
          self.$router.push({
            name: 'EditFlightBooking', 
            params: { 
              orderReference: orderReference,
              email: email
            }
          });
        } 
        if(!result) {
          self.showFieldErrors = true;
        }
      })
      
      
    }
  },
  computed: {
    ...mapGetters ([
      'getAgencySettings'
    ])
  }
}
</script>
